import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import {
  INSURANCE_QUOTATIONS_DATA_QUERY,
  INSURANCE_TYPES_QUERY
} from "features/insuranceDocument/queries/insuranceDocumentQueries";
import { useDictionaryHandling, useQueryWithSimpleErrorHandling, useInsuranceTypeConfiguration } from "hooks";
import OfferHistoryContainer from "features/insuranceDocument/edit/general/offersHistory/components/OfferHistoryContainer";
import CascoQuotationsHistoryContainer from "features/insuranceDocument/edit/general/cascoOffersHistory/components/CascoQuotationsHistoryContainer";
import { insuranceTypeNames } from "constants/defaultValues";

const InsuranceOfferHistoryContainer = ({ documentId }) => {
  const [insuranceData, setInsuranceData] = useState({});
  const { rcaInsuranceTypeConfiguration, cascoInsuranceTypeConfiguration } = useInsuranceTypeConfiguration(
    new Array(insuranceTypeNames.RCA, insuranceTypeNames.CASCO)
  );

  useQueryWithSimpleErrorHandling(INSURANCE_QUOTATIONS_DATA_QUERY, {
    variables: { documentId },
    onCompleted: data => {
      setInsuranceData(data?.insuranceData);
    }
  });

  const { getCodeById: getInsuranceTypeCodeById } = useDictionaryHandling(INSURANCE_TYPES_QUERY, "insuranceTypes");
  const insuranceTypeCode = useMemo(
    () => getInsuranceTypeCodeById(insuranceData.insuranceTypeId),
    [getInsuranceTypeCodeById, insuranceData.insuranceTypeId]
  );

  return (
    <>
      {insuranceTypeCode === rcaInsuranceTypeConfiguration?.PropertyCode && (
        <OfferHistoryContainer documentId={documentId} />
      )}
      {insuranceTypeCode === cascoInsuranceTypeConfiguration?.PropertyCode && (
        <CascoQuotationsHistoryContainer documentId={documentId} />
      )}
    </>
  );
};

InsuranceOfferHistoryContainer.propTypes = {
  documentId: PropTypes.number.isRequired
};

export default InsuranceOfferHistoryContainer;
